var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHypernativeIcon = function SvgHypernativeIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7352_86858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73817 1.08327C4.86249 1.07808 4.97768 1.149 5.02962 1.26275L6.68023 4.87771C6.76 5.02473 6.83425 5.07086 6.87836 5.08951C6.93263 5.11246 6.98525 5.11415 7.07166 5.11415L10.8112 5.12044H10.8119L10.8243 5.12071H10.8252C10.9693 5.12728 11.0903 5.23463 11.1138 5.37912L11.6907 8.92928L12.2645 12.0929C12.2743 12.1466 12.2697 12.2019 12.2512 12.2533L11.3535 14.7483C11.3114 14.8654 11.2033 14.9456 11.0796 14.9514C10.9559 14.9573 10.8408 14.8877 10.7879 14.7751L9.0776 11.1329C9.07449 11.1263 9.0716 11.1195 9.06893 11.1127C9.01671 10.9772 8.90024 10.8979 8.76806 10.8979L5.10894 10.8916C4.95996 10.8915 4.83252 10.7838 4.80685 10.6362L3.61284 3.76622C3.60364 3.7132 3.6084 3.65861 3.62662 3.60801L4.46261 1.28645C4.50499 1.16878 4.61386 1.08849 4.73817 1.08327ZM7.49604 7.07128C7.37413 7.07128 7.24089 7.16439 7.19846 7.27922L6.64675 8.77211C6.60431 8.88694 6.66873 8.98005 6.79063 8.98011H8.3757C8.49761 8.98005 8.63084 8.88694 8.67328 8.77211L9.22499 7.27922C9.26743 7.16444 9.20299 7.07133 9.0811 7.07128H7.49604Z",
    fill: "url(#paint0_linear_7352_86858)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7352_86858",
    x1: 4.69576,
    y1: 1.08301,
    x2: 11.1733,
    y2: 14.9284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BEFEF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7352_86858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.83333,
    height: 14,
    fill: "white",
    transform: "translate(3.5 1)"
  })))));
};
export default SvgHypernativeIcon;